import { getDeviationPath, getDeviationResourceType, } from '../../DeviationViews/_helpers';
import matchRoutes from '../../redux/routing/matchRoutes';
import { getDeviationEntityId, deviationSchema, } from '../../redux/normalizr/schemas/deviation';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import { FEEDBACK_PAGE_DUPERBROWSE_ITEMID } from './constants';
import isString from 'lodash/isString';
import isNumber from 'lodash/isNumber';
export function isDeviation(item) {
    return item.hasOwnProperty('deviationId');
}
export function isDeviationStream(stream) {
    return stream.items.every(isDeviation);
}
export function isNormalizedStream(stream) {
    return (stream.items.every(function (item) { return isNumber(item) || isString(item); }) &&
        !!stream.itemSchema);
}
export function getStreamItemId(item) {
    if (item === undefined) {
        return;
    }
    if (isDeviation(item)) {
        return item.deviationId;
    }
    if (isNumber(item) || isString(item)) {
        return item;
    }
}
export function getNormalizedStreamItemId(item) {
    if (isNumber(item) || isString(item)) {
        return item;
    }
    if (isDeviation(item)) {
        return getDeviationEntityId(item);
    }
}
export function getStreamItemUrl(item) {
    if (isDeviation(item)) {
        return getDeviationPath(item);
    }
    if (item === FEEDBACK_PAGE_DUPERBROWSE_ITEMID) {
        return '/notifications';
    }
}
export function getHtmlIdForStreamItem(stream, itemId) {
    return "duper-".concat(stream.streamId, "-").concat(itemId);
}
export function isDuperbrowseLocation(location, ignoreState) {
    if (ignoreState === void 0) { ignoreState = false; }
    // if there is known state, it's ours for sure
    if (!ignoreState &&
        location.state &&
        (location.state.hasOwnProperty('duperbrowseState') ||
            location.state.hasOwnProperty('duperbrowseRoot'))) {
        return true;
    }
    var routeMatches = matchRoutes({
        key: 'devpagelike',
        path: [
            '/:username/art/:deviationIdLike',
            '/:username/journal/:deviationIdLike',
            '/:username/status-update/:deviationIdLike',
            '/:username/poll/:deviationIdLike',
            '/:username/commission/:deviationIdLike',
            '/:username/tier/:deviationIdLike',
        ],
        exact: true,
    }, location.pathname, false);
    return routeMatches.length > 0;
}
export function getDuperbrowseItemSchema(schema) {
    switch (schema) {
        case 'deviation':
            return deviationSchema;
        default:
    }
}
export function getBasicBiDataForDuperItem(item) {
    if (isDeviation(item)) {
        return {
            itemid: item.deviationId,
            typeid: getDeviationResourceType(item),
        };
    }
}
export function getBiEventData(currentItem, direction, nextItem) {
    var _a, _b;
    var _c = (_a = getBasicBiDataForDuperItem(currentItem)) !== null && _a !== void 0 ? _a : {}, itemid = _c.itemid, typeid = _c.typeid;
    var next_itemid = ((_b = (nextItem && getBasicBiDataForDuperItem(nextItem))) !== null && _b !== void 0 ? _b : {}).itemid;
    return {
        evid: BiEventType.NAVIGATION_ARROW_CLICK,
        direction: direction === 'prev' ? 'previous' : direction,
        itemid: itemid,
        typeid: typeid,
        next_itemid: next_itemid,
    };
}
//# sourceMappingURL=helpers.js.map